import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
const sizes = {
    md: {
        betweenSpace: 'ml-4',
        main: 'text-28',
        unit: 'xs',
    },
    sm: {
        betweenSpace: 'ml-4',
        main: 'text-25',
        unit: 'xs',
    },
    xs: {
        betweenSpace: 'ml-4',
        main: 'text-22',
        unit: 'xs',
    },
    xxs: {
        betweenSpace: 'ml-4',
        main: 'text-18',
        unit: 'xs',
    },
};
export const WithUnitText = (props) => {
    const { classNames = null, mainColor = 'base', mainText, size, unitColor = 'base', unitText, } = props;
    return (_jsxs("div", Object.assign({ className: classNames === null || classNames === void 0 ? void 0 : classNames.wrap }, { children: [_jsx(Text, Object.assign({ className: clsx('align-baseline', sizes[size].main, classNames === null || classNames === void 0 ? void 0 : classNames.main), color: mainColor, fontFamily: 'alpha', isBold: true, size: 'none', tagName: 'span' }, { children: mainText })), _jsx(Text, Object.assign({ className: clsx('align-baseline', sizes[size].betweenSpace, classNames === null || classNames === void 0 ? void 0 : classNames.unit), color: unitColor, size: sizes[size].unit, tagName: 'span' }, { children: unitText }))] })));
};
export const withUnitTextSizes = sizes;
